export default __webpack_public_path__ + "static/media/bvdg_logo.028188fe.png";